import { render, staticRenderFns } from "./DayStatus.vue?vue&type=template&id=5fa67d4e"
import script from "./DayStatus.vue?vue&type=script&lang=js"
export * from "./DayStatus.vue?vue&type=script&lang=js"
import style0 from "./DayStatus.vue?vue&type=style&index=0&id=5fa67d4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports